package com.iptvplayer.shared.di

import com.iptvplayer.shared.data.local.db.DatabaseDriverFactory
import com.iptvplayer.shared.data.local.preferences.TokenStorage
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.engine.js.Js
import org.koin.core.module.Module
import org.koin.dsl.module

actual val platformModule: Module = module {
    single { TokenStorage() }
    single { DatabaseDriverFactory() }
    single<HttpClientEngine> { Js.create {} }
}
